import { render, staticRenderFns } from "./DemoDataBrowser.vue?vue&type=template&id=44ebe71c"
import script from "./DemoDataBrowser.vue?vue&type=script&lang=js"
export * from "./DemoDataBrowser.vue?vue&type=script&lang=js"
import style0 from "./DemoDataBrowser.vue?vue&type=style&index=0&id=44ebe71c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports